<template>
  <div class="content-wrapper">
    <!-- Content Header (Page header) -->
    <section class="content-header">
      <h1>
        Private Skins
        <small>Private Skin list</small>
      </h1>
    </section>

    <!-- Main content -->
    <section class="content">



      <div class="row">
        <div class="ui six stackable cards" id="skins-cards"  v-if="skins.images.length">
          <div :class="'col-sm-6 col-md-4 card col-lg-' + bigScreenSkins" :data-skin-id="item.id" v-for="item in skins.visible_images">
              <img class="card-img-top" :src="baseUrl2 + '/public/images/skins/'+item.skin_name+'.png'">
              <div class="card-block">

                <div class="card-text">
                  <span v-if="role >= 33">{{ item.ip }}</span> <span class="pull-right" v-if="role >= 33">{{ item.approved_by}}</span>
                </div>
              </div>
              <div class="card-footer">
                <h4 class="text-center card-title mt-3">{{ item.user_id }}</h4>
                <h4 class="text-center card-title mt-3" >{{ decodeURI(item.nickname) }}</h4>
                  <!--<a style="font-size:14px;" :href="'https://fb.com/' + item.facebook_id"> | {{ item.firstname}} {{ item.lastname}}</a>-->
                <!--</h4>-->


                <button @click="removePrivateSkinDB(item.id, item.skin_name)" class="btn btn-danger float-right btn-sm">Delete</button>

              </div>
          </div>
        </div>



      </div>
    </section>
  </div>
</template>

<script>
  export default {
    name: 'Private',

    data: function () {
      return {
        baseUrl2: 'https://agar.rs',
        loading: true,
        skins: new Form({
          images: [],
          visible_images: [],
          skin_name: ''
        }),
        skinSearch: '',
        isActiveSearch: false,
        scrollCalled: 0,
        isLoadingNew: false,
        role: 1,
        bigScreenSkins: 3

      }
    },
    methods: {
      getSkinsDB: function () {
        var self = this
        this.skins.post(baseUrl + 'Skins/getPrivateSkinList').then(function (result) {
          self.skins.images = result.list
          self.skins.visible_images = result.list
          self.loading = false
        }, function (reason) {
          // rejection
        })
      },
      getSkinsDBNext: function () {
        var self = this

        this.isLoadingNew = true
        var data = {}
        data['position'] = $('.card').last().attr('data-skin-id')

        this.skins.post(baseUrl + 'Skins/getPrivateSkinListNext', data).then(function (result) {
          self.skins.visible_images = self.skins.visible_images.concat(result.list)
          self.scrollCalled = 0
          self.isLoadingNew = false
        }, function (reason) {
          // rejection
        })
      },
      // Admin functions
      removePrivateSkinDB: function (id, name) {
        var self = this
        var data = {
          'user_id': localStorage.user_id,
          'token_header': localStorage.token_header,
          'token_log': localStorage.token_log,
          'name': name,
          'id': id
        }
        this.skins.post(baseUrl + 'Skins/removePrivateSkin', data).then(function (result) {
          if (result.status === 1) {
            self.skins.visible_images.find((o, i) => {
              if (o.skin_name === data.name) {
                if (i >= 0) {
                  self.skins.visible_images.splice(i, 1)
                  return 0
                }
              }
            })
          }
          if (result.status === 2) {
            // not allowed to change
            // set user role?
            localStorage.setItem('role', result.role)
          }
          // error
          if (result.status !== 1) {
            alert('Greska. Skin je vec obrisan')
          }
        }, function (reason) {
          // rejection
        })
      }
    },
    updated () {
      var self = this
      // Load new images on scroll
      $(window).scroll(function (event) {
        if (self.scrollCalled === 0) {
          if ($(this).scrollTop() + $(this).innerHeight() >= $('body')[0].scrollHeight) {
            if (self.skinSearch.length < 3) {
              self.scrollCalled = 1
              self.getSkinsDBNext()
            }
          }
        }
      })
    },
    created: function () {
      if (screen.width > 1500) {
        this.bigScreenSkins = 2
      }
      this.getSkinsDB()
      this.role = this.$store.state.role
    }
  }
</script>

<style>
@media (min-width: 992px) {
  .card-text {
    min-height: 30px;
  }
}
</style>



// WEBPACK FOOTER //
// Private.vue?0f3ff6dd